/*
 * A&M JOYAS - Aviso y bloqueo en la página de producto para productos
 * adicionales (tag "producto_adicional").
 *
 * Comportamiento:
 *  - Si el carrito no tiene ningún producto principal, el botón de
 *    "Agregar al carrito" de este producto aparece deshabilitado con un
 *    mensaje explicando que primero hay que agregar un producto principal.
 *  - Si el producto tiene además un tag "max_N" (ej. "max_2"), se indica
 *    cuántas unidades se pueden llevar en total según los productos
 *    principales que haya en el carrito, y cuántas más se pueden agregar.
 *  - Todo esto se actualiza en vivo cada vez que el carrito cambia (por
 *    ejemplo, si la clienta agrega un producto principal después).
 *  - Esto es un aviso/bloqueo del lado de la página de producto; el ajuste
 *    real de cantidades en el carrito lo hace assets/addon-gating.js.
 */
(function () {
  if (window.__addonPdpGatingInit) return;
  window.__addonPdpGatingInit = true;

  var ADDON_TAG = 'producto_adicional';
  var MAX_TAG_PATTERN = /^max_(\d+)$/i;
  var tagsCache = {};

  function fetchTags(handle) {
    if (tagsCache[handle]) return Promise.resolve(tagsCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        tagsCache[handle] = p.tags || [];
        return tagsCache[handle];
      })
      .catch(function () {
        tagsCache[handle] = [];
        return [];
      });
  }

  function obtenerLimitePorPrincipal(tags) {
    for (var i = 0; i < tags.length; i++) {
      var match = MAX_TAG_PATTERN.exec(tags[i]);
      if (match) return parseInt(match[1], 10);
    }
    return null;
  }

  function pintarMensaje(el, texto) {
    if (texto) {
      el.textContent = '✨ ' + texto;
      el.style.display = 'block';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  function actualizarGate(el, cart) {
    var handle = el.getAttribute('data-product-handle');
    var submitId = el.getAttribute('data-submit-id');
    var btn = document.getElementById(submitId);
    if (!btn) return Promise.resolve();

    // Si el botón ya estaba deshabilitado por otro motivo (sin stock, etc.),
    // no lo tocamos para no ocultar ese estado.
    if (btn.hasAttribute('disabled') && !btn.hasAttribute('data-addon-pdp-disabled')) {
      return Promise.resolve();
    }

    return fetchTags(handle).then(function (tagsDeEsteProducto) {
      var handlesEnCarrito = [];
      cart.items.forEach(function (item) {
        if (handlesEnCarrito.indexOf(item.handle) === -1) handlesEnCarrito.push(item.handle);
      });

      return Promise.all(handlesEnCarrito.map(fetchTags)).then(function () {
        var totalPrincipalQty = 0;
        var qtyDeEsteProductoEnCarrito = 0;

        cart.items.forEach(function (item) {
          var tags = tagsCache[item.handle] || [];
          if (tags.indexOf(ADDON_TAG) === -1) {
            totalPrincipalQty += item.quantity;
          }
          if (item.handle === handle) {
            qtyDeEsteProductoEnCarrito += item.quantity;
          }
        });

        function deshabilitar(mensaje) {
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('data-addon-pdp-disabled', 'true');
          pintarMensaje(el, mensaje);
        }

        function habilitar(mensaje) {
          btn.removeAttribute('disabled');
          btn.removeAttribute('data-addon-pdp-disabled');
          pintarMensaje(el, mensaje);
        }

        if (totalPrincipalQty === 0) {
          deshabilitar(
            'Agrega primero un producto que no sea adicional de la tienda para poder llevar este producto.'
          );
          return;
        }

        var limite = obtenerLimitePorPrincipal(tagsDeEsteProducto);
        if (limite === null) {
          habilitar('');
          return;
        }

        var permitido = limite * totalPrincipalQty;
        var restante = permitido - qtyDeEsteProductoEnCarrito;

        if (restante <= 0) {
          deshabilitar(
            'Ya tienes el máximo permitido de este producto en tu carrito (' + permitido + '). ' +
              'Agrega más productos principales para poder llevar más unidades.'
          );
        } else {
          habilitar(
            'Puedes llevar hasta ' + permitido + ' unidad(es) de este producto según lo que tienes en tu carrito. ' +
              'Ya tienes ' + qtyDeEsteProductoEnCarrito + ', puedes agregar ' + restante + ' más.'
          );
        }
      });
    });
  }

  function revisarTodo() {
    var elementos = document.querySelectorAll('.addon-pdp-gate');
    if (!elementos.length) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        elementos.forEach(function (el) {
          actualizarGate(el, cart);
        });
      })
      .catch(function () {});
  }

  function suscribirse() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, revisarTodo);
      revisarTodo();
    } else {
      setTimeout(suscribirse, 250);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', suscribirse);
  } else {
    suscribirse();
  }
})();
